import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AlbionImageService {
  getItemImageUrl(uniqueName: string, quality?: number, size: number = 25, locale?: string): string {
    let url = `${environment.albionImage.baseUrl}${uniqueName}.png?`;
    if (quality) url += `quality=${quality}&`;
    url += `size=${size}&`;
    if (locale) url += `locale=${locale}&`;
    return url;
  }

  getDestinyBoardImageUrl(id: string): string {
    let url = `${environment.albionImage.destinyBoardBaseUrl}${id}.png?`;
    return url;
  }
}
